export default __webpack_public_path__ + "static/media/Invoices_Active.ffb1ba41.svg";